import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import React, { useEffect } from "react";
import Card from "react-bootstrap/Card";
import { Col, Row } from "react-bootstrap";
import SwitchCustom from "../Switches/Switch";
import { Radio } from "@mui/material";
import { useTranslation } from "react-i18next";
import { setFormat } from "../../Redux/DownloadSlice/downloadSlice";
import { useDispatch } from "react-redux";
const ImageType = ({ downloadState }) => {
  const [selectedValue, setSelectedValue] = React.useState(
    downloadState ? downloadState.format : "jpg"
  );
  const { t } = useTranslation();
  const [checked, setChecked] = React.useState(false);

  const handleChangeSwitch = (event) => {
    setChecked(event.target.checked);
    if (event.target.checked) setSelectedValue(selectedValue + "a");
    else {
      let oldChoice = (selectedValue + "").slice(0, -1);
      if (oldChoice) setSelectedValue(oldChoice);
      else {
        setSelectedValue("jpg");
      }
    }
  };
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setFormat(checked ? 0 : selectedValue));
  }, [checked, selectedValue]);
  useEffect(() => {
    if (!downloadState.Format) {
      setSelectedValue(selectedValue + "a");
      setChecked(true);
    } else {
      setChecked(false);
      setSelectedValue(downloadState.Format);
    }
  }, []);
  const controlProps = (item) => ({
    checked: selectedValue === item,
    onChange: handleChange,
    value: item,
    name: "color-radio-button-demo",
    inputProps: { "aria-label": item },
  });

  useEffect(() => {
    setSelectedValue(downloadState.Format);
  }, []);
  return (
    <Card className="bg_grey">
      <Card.Header>
        <Col className="p-1 d-flex justify-content-between">
          <Row className="productSans text_15 d-flex justify-content-center align-items-center">
            {t("DownloadImage.Format")}
          </Row>
          <Row className="p-0 m-0">
            <FormGroup sx={{ p: 0, m: 0 }}>
              <FormControlLabel
                control={
                  <SwitchCustom
                    checked={checked}
                    onChange={handleChangeSwitch}
                    sx={{ p: 0, m: 0 }}
                  />
                }
              />
            </FormGroup>
          </Row>
        </Col>
      </Card.Header>
      <Card.Body className="py-0">
        <Col className="p-1 d-flex justify-content-between align-items-center">
          <Row className="Aktiv_Medium m-0 text_16 d-flex justify-content-center align-items-center">
            {t("DownloadImage.JPG")}
          </Row>
          <Row className="m-0 d-flex justify-content-center align-items-center">
            <Radio
              disabled={checked}
              {...controlProps("jpg")}
              sx={{
                "&.Mui-checked": {
                  color: "#F35B6A",
                },
              }}
            />
          </Row>
        </Col>

        <Col className="border-top p-1 d-flex justify-content-between align-items-center">
          <Row className="Aktiv_Medium m-0 text_16 d-flex justify-content-center align-items-center">
            {t("DownloadImage.PNG")}
          </Row>
          <Row className="m-0 d-flex justify-content-center align-items-center">
            <Radio
              disabled={checked}
              {...controlProps("png")}
              sx={{
                "&.Mui-checked": {
                  color: "#F35B6A",
                },
              }}
            />
          </Row>
        </Col>
      </Card.Body>
    </Card>
  );
};

export default ImageType;
